export enum DictCodeEnmu {
    //报价单状态
    QUOTATION_DRAFT = 'quotation.draft',
    QUOTATION_INIT = 'quotation.init',
    QUOTATION_FINISH = 'quotation.finish',
    QUOTATION_TRANSFERED = 'calculate.transferred',

    //核算单状态
    CALCULATE_DRAFT = 'calculate.draft',
    CALCULATE_INIT = 'calculate.init',
    CALCULATE_FINISH = 'calculate.finish',
    CALCULATE_TRANSFERED = 'calculate.transferred',

    // 故障报修记录
    REPAIR_INIT = 'repair.init',
    REPAIR_TRANSFERED = 'repair.transferred',

    // 400派工记录
    INIT = 'send.init',
    SENDWORK = 'send.sendwork',
    SENDEND = 'send.end',

    //数据类型
    DATA_TYPE = 'data-type',
    DATA_TYPE_TEXT = 'data-type.text',
    DATA_TYPE_DIGIT = 'data-type.digit',

    //车辆品牌
    VEHICLE_BRAND = 'vehicle-brand',

    //车辆类型
    VEHICLE_TYPE = 'vehicle-type',

    //车辆类型-挂车
    VEHICLE_TYPE_TRAILER = 'vehicle-type.trailer',

    //大包类型
    TCO_TYPE = 'tco-type',
    //大包类型
    BILL_METHOD = 'bill-method',

    //驱动形式
    DRIVE_TYPE = 'drive-type',

    //驱动形式
    DRIVE_TYPE_42 = '050001',
    DRIVE_TYPE_64 = '050002',
    DRIVE_TYPE_62 = '050003',
    DRIVE_TYPE_84 = '050004',

    //燃料类型
    FUEL_TYPE = 'fuel-type',
    //排放标准
    EMISSION_STANDARD = 'emission-standard',
    //里程段
    KILOMETER_SECTION = 'kilometer-section',
    SYSTEM_TYPE = 'system-type',
    ORDER_LIST = '014',

    SHOUFEI_shoufei = 'SHOUFEI_shoufei',
    SANBAO_sanbao = 'SANBAO_sanbao',
    YUNHAODABAO_yunhaodabao = 'YUNHAODABAO_yunhaodabao',

    // 消息预警类型
    WARNIMG_TYPE = 'warning-type',
    // 消息预警类型-风险
    WARNING_TYPE_RISK = 'warning-type.risk',
    // 消息预警类型-业务
    WARNING_TYPE_BUSINESS = 'warning-type.business',

    // 消息预警类型
    BUSINESS_TYPE = 'business-type',
    //故障报修
    BUSINESS_TYPE_REPAIRRECORD = 'business-type.repairRecord',
    //更换
    BUSINESS_TYPE_CHAGE = 'business-type.chage',
    //体检
    BUSINESS_TYPE_CHECK = 'business-type.check',
}
export const sourceAppOrBranch = {
    sourceApp: 'tco',
    branch: 'tco',
}
